export const NEWBUILDING_15_PROMO_PINS_DESKTOP = 'newbuilding_15_promo_pins_desktop';

export const EXPERIMENTS: string[] = [NEWBUILDING_15_PROMO_PINS_DESKTOP];
